/* eslint-disable */
// @ts-nocheck
__webpack_public_path__ = window.__webpack_public_path__;
// [ZL] This file forces the polyfill of features that are required by vendor (node_modules)
// code but has not been polyfilled by that vendor
import 'core-js/fn/array/fill.js';
import 'core-js/fn/array/find.js';
import 'core-js/fn/array/find-index.js';
import 'core-js/fn/array/from.js';
import 'core-js/fn/array/includes.js';
import 'core-js/fn/promise.js';
import 'core-js/es6/object.js';
import 'core-js/es6/map.js';
import 'core-js/es6/set.js';
import 'core-js/es6/symbol.js';
import 'core-js/fn/string/starts-with.js';
import 'core-js/fn/string/ends-with.js';
import 'core-js/fn/string/includes.js';
import 'core-js/fn/string/trim-left.js';
import 'core-js/fn/string/trim-right.js';
import setPrototypeOf from 'setprototypeof';

Object.setPrototypeOf = setPrototypeOf;

// Adapted from https://gist.github.com/paulirish/1579671
(() => {
  let lastTime = 0;
  const vendors = ['ms', 'moz', 'webkit', 'o'];

  if (!window.requestAnimationFrame) {
    vendors.forEach(vendor => {
      window.requestAnimationFrame = window[`${vendor}RequestAnimationFrame`];
      window.cancelAnimationFrame =
        window[`${vendor}CancelAnimationFrame`] || window[`${vendor}CancelRequestAnimationFrame`];
    });
    window.requestAnimationFrame = callback => {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = id => {
      clearTimeout(id);
    };
  }
})();

// Source: https://gist.github.com/paulirish/5438650
// @license http://opensource.org/licenses/MIT
// copyright Paul Irish 2015

// Date.now() is supported everywhere except IE8. For IE8 we use the Date.now polyfill
//   github.com/Financial-Times/polyfill-service/blob/master/polyfills/Date.now/polyfill.js
// as Safari 6 doesn't have support for NavigationTiming, we use a Date.now() timestamp for relative values

// if you want values similar to what you'd get with real perf.now, place this towards the head of the page
// but in reality, you're just getting the delta between now() calls, so it's not terribly important where it's placed

(function () {
  if ('performance' in window == false) {
    window.performance = {};
  }

  Date.now =
    Date.now ||
    function () {
      // thanks IE8
      return new Date().getTime();
    };

  if ('now' in window.performance == false) {
    var nowOffset = Date.now();

    if (performance.timing && performance.timing.navigationStart) {
      nowOffset = performance.timing.navigationStart;
    }

    window.performance.now = function now() {
      return Date.now() - nowOffset;
    };
  }
})();
